import Pages2023 from "./2023/routePages";

export default function BlogsPages() {
  return <Pages2023 />;
}
